<template>
	<div class="con">
		<div class="nav">
			<div class="nav-list" v-for="(item,index) in nav" @click="selfNavBtn(item.id)">
				<div class="text" :class="[item.id == navIndex ? 'navActive':'']">{{item.text}}</div>
			</div>
		</div>
		<div class="time">
			<van-icon name="arrow-left" size="25px" :disabled="isDis" @click="onTime" />
			<div>{{choosTime}}</div>
			<van-icon name="arrow" size="25px" :disabled="isDis" @click="nextTime" />
		</div>
		<div class="circular">
			<div class="cir-line">
				<div>24465</div>
				<p>诊疗收入</p>
			</div>
		</div>
		<div class="list">
			<div v-for="item in list" class="list-con">
				<div>
					<div class="list-con-num">{{item.num}}</div>
					<div>{{item.text}}</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'staSelf',
		data() {
			return {
				userInfo: JSON.parse(localStorage.getItem('userInfo')),
				nav: [{
						id: 0,
						text: '年'
					},
					{
						id: 1,
						text: '月'
					},
					{
						id: 2,
						text: '日'
					},
				],
				newText: '年',
				navIndex: 0,
				choosTime: '', //显示的时间
				saveTimeYear: '',
				saveTimeMonth: '',
				saveTimeDay: '',
				isDis: true, //防止猛击按钮
				list: [{
						id: 0,
						text: '出诊数',
						num: 567
					},
					{
						id: 1,
						text: '出诊时长',
						num: 4436
					},
					{
						id: 2,
						text: '就诊率',
						num: 4435
					},
					{
						id: 3,
						text: '处方数量',
						num: 434
					},

				],
				emUserInfo: JSON.parse(localStorage.getItem('emUserInfo'))
			}
		},
		methods: {
			//住院医生报表
			GetInpatYsReport() {
				let e = this.choosTime;
				let time = e.split("-");

				if(time[1] == undefined) {
					time[1] = '';
				}
				if(time[2] == undefined) {
					time[2] = '';
				}
				this.$Axios.Get('/getInpatYsReport?ghks=&ysdm=' + this.emUserInfo.userId + '&year=' + time[0] + '&month=' + time[1] + '&day=' + time[2], null).then(res => {
					console.log(res)
					this.$store.commit('Load', false)
					if(res.code == 0) {

					}
				}).catch(err => {
					this.$store.commit('Load', false)
					console.log(err)
				})
			},
			selfNewTime() {
				let newT = this.$timeformat.timestampToTime(new Date());
				let newTime = newT.split(" ")[0];
				let timeSplit = newTime.split("-");
				this.choosTime = timeSplit[0];
				this.saveTimeYear = new Date().getTime();
				this.saveTimeMonth = new Date().getTime();
				this.saveTimeDay = new Date().getTime();
			},
			//年月日
			selfNavBtn(e) {
				console.log(e)
				this.newText = this.nav[e].text;
				this.navIndex = e;
				let newT;
				switch(this.navIndex) {
					case 0:
						newT = this.$timeformat.timestampToTime(this.saveTimeYear);
						newT = newT.split(" ")[0];
						newT = newT.split("-");
						this.choosTime = newT[0];
						break;
					case 1:
						newT = this.$timeformat.timestampToTime(this.saveTimeMonth);
						newT = newT.split(" ")[0];
						newT = newT.split("-");
						this.choosTime = newT[0] + "-" + newT[1];
						break;
					case 2:
						newT = this.$timeformat.timestampToTime(this.saveTimeDay);
						newT = newT.split(" ")[0];
						newT = newT.split("-");
						this.choosTime = newT[0] + "-" + newT[1] + "-" + newT[2];
						break;
				}
				this.GetInpatYsReport()
			},
			//上一个
			onTime() {
				let that = this;
				if(this.isDis == true) {
					switch(this.navIndex) {
						case 0:
							let countTimeYear = this.saveTimeYear - 1000 * 60 * 60 * 24 * 30 * 12;
							this.saveTimeYear = countTimeYear;
							let cTimeYear = this.$timeformat.timestampToTime(countTimeYear);
							cTimeYear = cTimeYear.split(" ")[0];
							cTimeYear = cTimeYear.split("-");
							this.choosTime = cTimeYear[0];
							break;
						case 1:
							let countTimeMoth = this.saveTimeMonth - 1000 * 60 * 60 * 24 * 30;
							this.saveTimeMonth = countTimeMoth;
							let cTimeMoth = this.$timeformat.timestampToTime(countTimeMoth);
							cTimeMoth = cTimeMoth.split(" ")[0];
							cTimeMoth = cTimeMoth.split("-");
							this.choosTime = cTimeMoth[0] + "-" + cTimeMoth[1]
							break;
						case 2:
							let countTimeDay = this.saveTimeDay - 1000 * 60 * 60 * 24;
							this.saveTimeDay = countTimeDay;
							let cTimeDay = this.$timeformat.timestampToTime(countTimeDay);
							cTimeDay = cTimeDay.split(" ")[0];
							this.choosTime = cTimeDay
							break;
					}
					this.isDis = false;
					setTimeout(() => {
						that.isDis = true;
					}, 500)
				}
				this.GetInpatYsReport()
			},
			//下一个
			nextTime() {
				let that = this;
				if(this.isDis == true) {
					switch(this.navIndex) {
						case 0:
							let countTimeYear = this.saveTimeYear + 1000 * 60 * 60 * 24 * 30 * 12;
							this.saveTimeYear = countTimeYear;
							let cTimeYear = this.$timeformat.timestampToTime(countTimeYear);
							cTimeYear = cTimeYear.split(" ")[0];
							cTimeYear = cTimeYear.split("-");
							this.choosTime = cTimeYear[0];
							break;
						case 1:
							let countTimeMoth = this.saveTimeMonth + 1000 * 60 * 60 * 24 * 30;
							this.saveTimeMonth = countTimeMoth;
							let cTimeMoth = this.$timeformat.timestampToTime(countTimeMoth);
							cTimeMoth = cTimeMoth.split(" ")[0];
							cTimeMoth = cTimeMoth.split("-");
							this.choosTime = cTimeMoth[0] + "-" + cTimeMoth[1]
							break;
						case 2:
							let countTimeDay = this.saveTimeDay + 1000 * 60 * 60 * 24;
							this.saveTimeDay = countTimeDay;
							let cTimeDay = this.$timeformat.timestampToTime(countTimeDay);
							cTimeDay = cTimeDay.split(" ")[0];
							this.choosTime = cTimeDay
							break;
					}
					this.isDis = false;
					setTimeout(() => {
						that.isDis = true;
					}, 500)
				}
				this.GetInpatYsReport()

			},

		},
		mounted() {
			this.selfNewTime();
			console.log(this.emUserInfo)
			this.GetInpatYsReport()
		},
		created() {

		},
	}
</script>

<style scoped>
	.con {
		width: 100%;
		height: 100%;
		background: #27BEC4;
	}
	
	.nav {
		padding: 10px;
		display: flex;
		justify-content: center;
		background: #27BEC4
	}
	
	.nav-list {
		border: 1px solid #fff;
	}
	
	.text {
		padding: 10px 40px;
		color: #fff;
		font-size: 16px;
		text-align: center;
	}
	
	.navActive {
		background: #fff;
		color: #27BEC4;
	}
	
	.time {
		padding: 15px 0;
		display: flex;
		justify-content: space-around;
		align-content: center;
		font-size: 18px;
		background: #27BEC4;
		color: #fff;
	}
	
	.navActive {
		background: #fff;
		color: #000;
	}
	
	.circular {
		position: relative;
		margin: 20px auto;
		width: 200px;
		height: 200px;
		text-align: center;
		border: 1px solid #fff;
		border-radius: 50%;
		font-size: 30px;
		color: #fff;
	}
	
	.cir-line {
		position: absolute;
		left: 0;
		right: 0;
		top: 0;
		bottom: 0;
		margin: auto;
		width: 100px;
		height: 100px;
	}
	
	.cir-line p {
		margin-top: 5px;
		font-size: 16px;
	}
	
	.list {
		margin-top: 30px;
		padding: 10px;
		background: #27BEC4;
	}
	
	.list {
		display: flex;
		flex-wrap: wrap;
		justify-content: space-around;
	}
	
	.list-con {
		margin: 20px 0;
		padding: 15px 10px;
		font-size: 15px;
		width: 40%;
		background: linear-gradient(#ccc, #27BEC4);
		color: #FFF;
		border-radius: 15px;
	}
	
	.list-con-num {
		font-size: 30px;
	}
</style>